import React from 'react'

const Geo = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 20.9863C17.238 20.7269 21 16.8028 21 12H22.5V11H20.9451C20.4656 6.66303 16.9045 3.25484 12.5 3.01365V1.5H11.5V3.01365C7.09545 3.25484 3.53436 6.66303 3.05493 11H1.5V12H3C3 16.8028 6.76201 20.7269 11.5 20.9863V22.5H12.5V20.9863ZM11.5 5.5V4.01537C7.64812 4.2529 4.53374 7.21613 4.06189 11H5.5V12H4C4 16.2504 7.31463 19.7265 11.5 19.9846V18.5H12.5V19.9846C16.6854 19.7265 20 16.2504 20 12H18.5V11H19.9381C19.4663 7.21613 16.3519 4.2529 12.5 4.01537V5.5H11.5Z"
      fill="white"
    />
  </svg>
)

export default Geo
